// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { createResponseObj, generateHeaders } from '..'
import { vcBaseUrl } from '.'


type ClaimPromoResponse = (SuccessResponse & {
    message: string
}) | FailedResponse

export class ClaimPromoRequest extends Request {
    private constructor(promoId: string, init?: RequestInit) {
        super(`${vcBaseUrl}/promo/${promoId}/claim`, init)
    }

    static async init(promoId: string, init?: RequestInit) {
        return new ClaimPromoRequest(promoId, {
            ...init,
            method: 'GET',
            headers: await generateHeaders('Clerk-Token', init?.headers),
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<void> {
        const response = await fetch(this)
        const data = createResponseObj<ClaimPromoResponse>(await response.json())
        console.info('Claim Promo Response:', data)

        switch (data.status) {
            case 'successful': return
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}
